module.exports = __webpack_public_path__ + "81ee779a0b13433aab95345ff6c7cdc0.png";